<template>
  <div id="drop-area">
    <h4 v-if="!files.length">
      Drop Plans, Docs or Photos (No file size limitations)
      <p><small>or click here to browse</small></p>
    </h4>
    <div id="files">
      <file
        @remove="removeFile($event)"
        v-for="(file, index) in files"
        :key="index"
        :name="file.name"
        :size="file.size"
        id="file"
      />
    </div>
  </div>
</template>

<script>
import File from "./File.vue";

export default {
  name: "DropArea",
  components: { File },
  props: {
    files: [],
  },
  methods: {
    removeFile(name) {
      this.$emit("remove", name);
    },
  },
};
</script>

<style scoped>
h4 {
  color: #6c7b86;
  text-align: center;
  margin: 0;
  padding-top: 30px;
  font-size: 14px;
  font-weight: 600;
}

h4 p {
  margin-top: 4px;
}

h4 small {
  color: #8899a6;
  font-weight: 400;
}

#drop-area {
  cursor: pointer;
  background: #eaf4fd;
  border: 2px dashed #a3cdef;
  box-sizing: border-box;
  min-height: 120px;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 10px;
  padding: 10px;
  transition: background 0.2s ease, border-color 0.2s ease;
}

#files {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 4px;
}

#file {
  height: fit-content;
}
</style>
